module.exports = __webpack_public_path__ + "static/media/sea-turtle.b4cb7848.jpg";